import type { Components, Theme } from "@mui/material/styles";

export const MuiSelect: NonNullable<Components<Theme>["MuiSelect"]> = {
  defaultProps: { variant: "outlined", size: "medium" },
};
